module.exports = __webpack_public_path__ + "img/baseline-pause-24px.ce09c96c.svg";